import parseDate from './parseDate';

const isValidDate = (str: string) => parseDate(str) !== null;

export default isValidDate;
